import Vue from 'vue';
import i18n from 'vue-i18n';
import { fallbackLocale } from '@/i18n/i18n.config';
import { getPreferredLocale } from '@/i18n/getPreferredLocale';

// Load the different language files.
const requireComponent = require.context('./', true, /translations\/[\w-]+\.json$/);
const translationNames = [];
const translations = {};

requireComponent.keys().forEach(fileName => {
  const name = fileName.replace(/^.*[\\\/]/, '').replace(/\.\w+$/, '');

  // Store file name language code in array to later use for checking browser preference.
  if (!translationNames.includes(name)) {
    translationNames.push(name);
  }

  translations[name] = requireComponent(fileName);
});

Vue.use(i18n);

export default new i18n({
  locale: getPreferredLocale(translationNames) || fallbackLocale,
  fallbackLocale: fallbackLocale,
  messages: translations,
});
